import __isEmpty from 'lodash/isEmpty';
import styles from './capcalera.module.scss';
import Enllac from 'components/corporatiu/Enllac';
import Fila from 'components/corporatiu/Fila';
import Imatge from 'components/corporatiu/Imatge';

export default function Capcalera() {
    return (
        <div className={styles.header}>
            <Fila tipus='fixed' columnes='12'>
                <div className={styles.headerText}>
                    <h1>
                        <Enllac href='https://www.3cat.cat/videojocs/'>
                            <Imatge
                                src='/_resources/logos/3CatVideojocs.svg'
                                alt='Els videojocs en català de 3Cat'
                                width={408}
                                height={72}
                            />
                        </Enllac>
                    </h1>
                    <div className={styles.subheader}>Juga en català en consoles, mòbils i ordinadors</div>
                </div>
            </Fila>
        </div>
    );
}
